import { render, staticRenderFns } from "./invest.vue?vue&type=template&id=7cfdb236&scoped=true"
import script from "./invest.vue?vue&type=script&lang=js"
export * from "./invest.vue?vue&type=script&lang=js"
import style1 from "./invest.vue?vue&type=style&index=1&id=7cfdb236&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfdb236",
  null
  
)

export default component.exports